import { Controller } from "react-hook-form";
import { SelectField } from "../../ui";

interface SelectCostTypeProps {
    name: string;
    methods: any;
    disabled?: boolean;
    required?: boolean;
    label?: string;
}

export enum CostTypeEnum {
    DIRECT = 'direct',     // Custos diretamente ligados à execução da obra
    INDIRECT = 'indirect'  // Custos de apoio, administração e despesas gerais
}

export function SelectCostType({
    name,
    methods,
    disabled = false,
    required = false,
    label = "Tipo de Custo",
}: SelectCostTypeProps) {
    return (
        <Controller
            name={name}
            control={methods.control}
            render={({ field }) => (
                <SelectField
                    label={label}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    required={required}
                    disabled={disabled}
                >
                    <option value={CostTypeEnum.DIRECT}>Direto</option>
                    <option value={CostTypeEnum.INDIRECT}>Indireto</option>
                </SelectField>
            )}
        />
    );
}
